module.exports = __webpack_public_path__ + "static/media/tags.d737bc2f.svg";